<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import { FormKitNode } from '@formkit/core'
import { useI18n } from 'vue-i18n'

const { parent, form, showSuccessMessage, errors, onSubmit, onSuccessAcknowledgement } = useCommentForm()
const { t } = useI18n()
</script>
<template>
<FormKitLazyProvider config-file="true">

  <ClientOnly>
    <Teleport :to="`#${parent.current}`">
      <div class="form">
        <div v-if="showSuccessMessage" class="message-success">
          <p>{{ t('news.detail.comments.form.success') }}</p>
          <Button primary @click="onSuccessAcknowledgement"> ok </Button>
        </div>
        <FormKit
          v-else
          type="form"
          :actions="false"
          :errors="errors"
          @submit="onSubmit"
          @node="(n: FormKitNode) => (form = n)"
        >
          <div class="split">
            <Input id="comment-form-name" name="name" :label="t('news.detail.comments.form.name')" :required="true" />
            <Input
              id="comment-form-email"
              name="email"
              :label="t('news.detail.comments.form.email')"
              :required="true"
            />
          </div>
          <Textarea id="comment-form-body" name="body" :label="t('news.detail.comments.form.body')" :required="true" />
          <Button primary class="submit-button">
            {{ t('news.detail.comments.form.save') }}
          </Button>
        </FormKit>
      </div>
    </Teleport>
  </ClientOnly>

</FormKitLazyProvider>
</template>
<style lang="scss" scoped>
.form {
  @include fluid(margin-top, 16px, 32px);
}
.message-success {
  padding: 16px;
  border: 1px solid var(--c-primary);
  color: var(--c-primary);
  text-align: center;
}
.formkit-form {
  display: grid;
  grid-template-columns: 100%;
  gap: var(--gap);

  &[data-loading] {
    opacity: 0.5;
    pointer-events: none;
  }
}
.split {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: var(--gap);

  @include breakpoint(tl) {
    grid-template-columns: 1fr 1fr;
  }
}
.button {
  justify-self: end;
}
</style>
